export default __webpack_public_path__ + "static/media/calander-icon.16bdf2d1.svg";